import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { getInclusionsViewableLuxPlusTier } from 'selectors/luxPlusSelectors'

interface Props {
  departure?: App.CruiseDepartureDetails
  luxPlusInclusionsByTier?: App.LuxPlusInclusionsByTier
  booking?: App.Cruises.CruiseBooking
  cruiseItem?: App.Checkout.CruiseItem
  cabinRate?: App.Cruises.BookingCabinRate
}

type CruiseInclusionsResult = {
  inclusionDetails?: App.Cruises.OfferInclusionDetails
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
}

export function useCruiseOfferInclusions({
  departure,
  luxPlusInclusionsByTier,
  booking,
  cruiseItem,
  cabinRate,
}: Props): CruiseInclusionsResult {
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const inclusionsViewableLuxPlusTier = useAppSelector(getInclusionsViewableLuxPlusTier)

  const inclusionsByTier = luxPlusInclusionsByTier ||
    departure?.luxPlusInclusionsByTier ||
    cruiseItem?.luxPlusInclusionsByTier ||
    cabinRate?.luxPlusInclusionsByTier

  const departureLuxPlusInclusions = inclusionsByTier?.[inclusionsViewableLuxPlusTier] || []
  const luxPlusInclusions = booking?.luxPlusInclusions || departureLuxPlusInclusions || []

  const standardInclusions = booking?.standardInclusions ||
    departure?.standardInclusions ||
    cruiseItem?.standardInclusions ||
    cabinRate?.standardInclusions ||
    []

  return {
    inclusionDetails: departure?.inclusionDetails,
    luxPlusInclusions: luxPlusEnabled ? luxPlusInclusions : [],
    standardInclusions,
  }
}
